/*
 *  This file contains shared function and logic used in controllers
 */

/* branding, cta-logo, full-color controllers */
export const getMetaContentByName = (name) => {
  const sel = document.querySelector("meta[name='" + name + "']")
  return sel ? sel.getAttribute("content") : null
}

export const fetchLogo = (string, element) => {
  if (getMetaContentByName("branded")) {
    fetch(getMetaContentByName(string))
      .then((response) => response.text())
      .then((html) => {
        element.innerHTML = html
      })
  } else {
    // element.innerHTML = <i class="bz-pro bz-pro-banzai"></i>
  }
}

export const fetchStaticAsset = (target, path) => {
  fetch(`https://static-app-misc.banzai.org/img/${path}`)
    .then((response) => response.text())
    .then((html) => {
      target.innerHTML = html
    })
}

/* header controllers */

export const showMenu = (targets, boolean) =>
  targets.forEach((el) => {
    el.classList.toggle("show", boolean)
  })

/* sticky header controllers */

export const onScroll = () => {
  window.addEventListener("scroll", function () {
    var body = document.body
    var scrollFromTop = hasClass(body, "with-banner") ? 114 : 80
    if (document.documentElement.scrollTop > scrollFromTop || document.body.scrollTop > scrollFromTop) {
      body.classList.add("down")
    } else {
      body.classList.remove("down")
    }
  })
}

/* lead, cta, sidebar controllers */

export const badNameError = "lead/bad-name"
export const badEmailError = "lead/bad-email"
export const unidentifiedError = "lead/unidentified"
export const errorTexts = {
  "lead/bad-name": "Please enter a valid name.",
  "lead/bad-email": "Please enter a valid email."
}

export const hide = (el) => {
  el.style.display = "none"
}

export const show = (el) => {
  el.style.display = "block"
}

export const addClass = (el, className) => {
  if (el.classList) {
    el.classList.add(className)
  } else {
    el.className += " " + className
  }
}

export const removeClass = (el, className) => {
  if (el.classList) {
    el.classList.remove(className)
  } else {
    var reg = new RegExp("(\\s|^)" + className + "(\\s|$)")
    el.className = el.className.replace(reg, " ")
  }
}

export const hasClass = (el, className) => {
  if (el.classList) {
    return el.classList.contains(className)
  } else {
    return new RegExp("(^| )" + className + "( |$)", "gi").test(el.className)
  }
}

export const getCumulativeOffset = (element) => {
  var top = 0
  var left = 0
  do {
    top += element.offsetTop || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)
  return {
    top: top,
    left: left
  }
}

export const getKey = (id) => id.split("-")[2] || id

export const getActiveModalView = (modalId, view) => {
  const active = document.getElementById(modalId).querySelector("[data-active]")
  active.removeAttribute("data-active")
  view.setAttribute("data-active", null)
}

export const onModalClose = (modalId, keydownTarget, errorcontentTarget) => {
  getActiveModalView(modalId, keydownTarget)
  if (errorcontentTarget) {
    errorcontentTarget.innerHTML = ""
  }
}

export const onSubmit = (modalId, formTarget, submitTarget, errorcontentTarget, errorTarget, successTarget, entryTarget, afterSubmitText) => {
  let xmlhttp = new XMLHttpRequest()
  let lead = {}
  let response
  for (let i = 0; i < formTarget.elements.length - 1; i++) {
    let e = formTarget.elements[i]
    if (e.id) {
      lead[getKey(e.id)] = e.value
    }
  }
  xmlhttp.open("POST", formTarget.dataset.value, true)
  xmlhttp.setRequestHeader("Content-Type", "application/json")
  xmlhttp.send(JSON.stringify(lead))
  addClass(submitTarget, "saving")
  submitTarget.innerHTML = "Please wait..."
  xmlhttp.onreadystatechange = () => {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      submitTarget.innerHTML = afterSubmitText
      const response = xmlhttp.response === "" ? xmlhttp.response : JSON.parse(xmlhttp.response)["lead/error"]
      switch (response) {
        case badNameError:
          errorcontentTarget.innerHTML = errorTexts[badNameError]
          break
        case badEmailError:
          errorcontentTarget.innerHTML = errorTexts[badEmailError]
          break
        case unidentifiedError:
          addClass(errorTarget, "show")
          break
        default:
          if (entryTarget != undefined) {
            addClass(entryTarget, "hide")
          }
          addClass(successTarget, "show") /* to test */
      }
    }
  }
}

export const onSubmitKeydown = (e, onSubmitFn) => {
  if (e.keyCode === 13) {
    onSubmitFn()
    e.preventDefault()
    e.stopPropagation()
  }
}
